/**
 * Hook that returns the effective company ID.
 * If SuperAdmin is impersonating, returns the impersonated company ID.
 * Otherwise, returns the user's own company ID.
 */
import { useAuth } from '../contexts/AuthContext';
import { useAdmin } from '../contexts/AdminContext';

export const useEffectiveCompanyId = (): string => {
  const { user } = useAuth();
  const { selectedCompanyId, isImpersonating } = useAdmin();

  if (isImpersonating && selectedCompanyId) {
    return selectedCompanyId;
  }

  // Superadmin sin impersonar no tiene empresa real
  if (user?.role === 'superadmin') {
    return '';
  }

  return user?.companyId || '';
};
